<template>
	<div class="modal" :id="modal.selector" tabindex="-1" role="dialog" aria-hidden="true">
		<div class="modal-dialog modal-lg" role="document">
			<div class="modal-content">
				<loading :active="loading">
					<img :src="$env.ROOT + '/img/loading.gif'" width="55px" height="55px">
				</loading>
				<div class="modal-header">
					<div class="btn-toolbar pull-right" role="toolbar">
						<div class="btn-group" role="group" aria-label="...">
							<button type="button" class="close" data-dismiss="modal" aria-label="Close">
								<span aria-hidden="true">&times;</span>
							</button>
						</div>
					</div>
					<h4  class="modal-title">Editar solicitud</h4>
				</div>
				<div class="modal-body" v-if="request">
					<div class="row">
						<div class="col-md-12">
							<div class="form-group" :class="{ 'has-error' : errors.has('title') }">
								<label class="control-label">Título</label>
								<input
									v-validate="'required'"
									name="title"
									data-vv-as="Título"
									v-model="request.title"
									type="text"
									class="form-control">
								<small v-show="errors.has('title')" class="form-text text-danger">
									{{ errors.first('title') }}
								</small>
							</div>
						</div>
					</div>
					<template v-if="request.form">
						<hr>
						<div class="row">
							<div class="col-md-12">
								<form-schema :html="request.form.html"></form-schema>
							</div>
						</div>
					</template>
					<template v-else>
						<template v-if="request.data">
							<template v-if="request.data.length">
								<div class="row">
									<template v-for="field in request.data">
										<template v-if="!hidden_fields.includes(field.id)">
											<div class="col-md-12">
												<div class="form-group">
													<label class="control-label">{{ field.name }}</label>
													<template v-if="field.id == 'comments'">
														<textarea
															rows="10"
															v-model="field.value"
															type="text"
															class="form-control">
														</textarea>
													</template>
													<template v-else>
														<input
															v-model="field.value"
															type="text"
															class="form-control">
													</template>
												</div>
											</div>
										</template>
									</template>
								</div>
							</template>
						</template>
					</template>
				</div>
				<div class="modal-footer">
					<button @click="validate" ref="btnStore" type="submit" class="btn btn-success">
						Guardar
					</button>
					<button type="button" class="btn btn-default" data-dismiss="modal">Cerrar</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import swal from 'sweetalert2'
	import VueElementLoading from 'vue-element-loading'
	import Form from './Form'

	export default {
		props: ['user', 'isAuth'],
		components: {
			'loading': VueElementLoading,
			'form-schema': Form,
		},
		data () {
			return {
				modal: {
					selector: 'requests-edit-' + new Date().getTime(),
				},
				loading: false,

				request: null,

				hidden_fields: [
					'referral_id'
				],
			}
		},
		methods: {
			open(request) {
				this.clearData()
				if(request) {
					this.request = JSON.parse(JSON.stringify(request));
				}
				this.$nextTick( () => this.loadData())
				var modal = $('#'+this.modal.selector)
				modal.modal('show')
			},
			close() {
				var modal = $('#'+this.modal.selector)
				modal.modal('hide')
			},
			clearData() {
				this.errors.clear()
				this.request = null
			},
			loadData() {
				if(this.request) {
					if(this.request.data) {
						if(this.request.form) {
							var data = this.request.data
							if(Object.keys(data).length) {
								var that = this
								data.forEach(function(field) {
									var id = field.id
									var value = field.value
									var query = 'form-' + that.request.form_id + '-' + id
									var input = document.getElementById(query)
									input.value = value
								})
							}
						}
					}
				}
				if(this.request.form) {
					let script = document.createElement('script')
					script.setAttribute('id', 'fsdfdsfdsf')
					script.text = this.request.form.scripts
					document.head.appendChild(script)
				}
			},
			getDomData() {
				if(this.request) {
					if(this.request.data) {
						var data = this.request.data
						var that = this
						data.forEach(function(field) {
							var id = field.id
							var query = 'form-' + that.request.form.id + '-' + id
							var input = document.getElementById(query)
							var tagName = input.tagName.toLowerCase()
							if(tagName == "textarea") {
								var editor = CKEDITOR.instances[query]
								if(editor) {
									field.value = editor.getData()
								} else {
									field.value = input.value
								}
							} else {
								field.value = input.value
							}
						})
						this.request.data = data
					}
				}
			},
			validate() {
				var that = this
				return this.$validator.validateAll().then((result) => {
					if(result) {
						that.update()
					}
					return result
				})
			},
			update () {
				if(this.request.form) {
					this.getDomData()
				}
				this.loading = true
				this.$http.put('admin/requests/' + this.request.id, this.request)
				.then(response => {
					swal(response.body.title, response.body.text, response.body.type)
					this.close()
					this.$emit('reload')
					this.loading = false
				}).catch(function(response) {
					console.log(response)
					this.close()
					this.$emit('reload')
					this.loading = false
					if(response.status == 409) {
						swal({
							title: response.body.title,
							text: response.body.text,
							type: response.body.type,
						})
					}
				})
			},
		},
	};
</script>


// WEBPACK FOOTER //
// src/components/requests/views/Edit.vue